import React from "react";
import { Link } from "react-router-dom";

/**
 * Casilla obligatoria de aceptación de la Política de Privacidad.
 * Se marca como `required` para que el navegador impida el envío del formulario
 * si no se ha aceptado.
 */
export default function PrivacyCheckbox({ checked, onChange, testId = "privacy-checkbox" }) {
    return (
        <label className="flex items-start gap-3 text-xs text-[#4A5568] leading-relaxed cursor-pointer">
            <input
                type="checkbox"
                required
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                data-testid={testId}
                className="mt-0.5 h-4 w-4 accent-[#082050] shrink-0"
            />
            <span>
                He leído y acepto la{" "}
                <Link
                    to="/politica-de-privacidad"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline text-[#082050]"
                >
                    Política de Privacidad
                </Link>
                .
            </span>
        </label>
    );
}
